export default "__VITE_ASSET__CerasprZ__"